// ** Third Party Components
import { useTranslation } from "react-i18next";

// ** Custom Components
import Text from "components/typography/Text";

// ** Utils & Helpers
import formatMessage from "utils/formatMessage";
import pseudoFormat from "utils/pseudoFormat";

// #####################################################

const FoundResultsCountText = ({ resultsCount, resultsType = "users" }) => {
	const { t } = useTranslation(["common"]);

	// #####################################################

	return (
		<Text mr={1}>
			{formatMessage(t(`filtersAndSelectors:foundItems`), {
				itemsCount: (
					<Text bold key="filtersAndSelectors:foundItems">
						{pseudoFormat(resultsCount)}
					</Text>
				),
				itemsType: t(
					`filtersAndSelectors:foundItemsType.${resultsType}`
				),
			})}
		</Text>
	);
};

// #####################################################

export default FoundResultsCountText;

// #####################################################
